/* eslint-disable */
import React, { PropTypes } from 'react';
import './css/RatingEmoji.css'
import $ from 'jquery';
import ConfigD from './util/ConfigD';

class RatingEmoji extends React.Component {

  constructor(props, context) {
    super(props, context);
    
    this.mouseOverImg = this.mouseOverImg.bind(this);
    this.mouseOutImg = this.mouseOutImg.bind(this);
    this.clickImg = this.clickImg.bind(this);
  }

  mouseOverImg(e){
      this.props.mouseOverImg(e);
  }

  mouseOutImg(){
    this.props.mouseOutImg();
  }

  clickImg(e){
    this.props.clickImg(e, this.props.pergunta);
  }

  componentWillReceiveProps(nextProps) {
    //console.log('reiniciar pagina', nextProps.reiniciarPagina)
    if (nextProps.reiniciarPagina) {
        $('input:radio').prop('checked',false);
    }
  }

  render() {
    
    return (
      
        <div className="cc-selector">
          <input id={'worried_big'+this.props.pergunta.mIdCampanhaPergunta}  type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="1"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/worried_big.png)'}} className="drinkcard-cc" htmlFor={'worried_big'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(1)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(1)}></label>
          <input id={'surprised_big'+this.props.pergunta.mIdCampanhaPergunta}  type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="1"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/surprised_big.png)'}} className="drinkcard-cc" htmlFor={'surprised_big'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(2)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(2)}></label>
          <input id={'sad_big'+this.props.pergunta.mIdCampanhaPergunta}  type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="1"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/sad_big.png)'}} className="drinkcard-cc" htmlFor={'sad_big'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(3)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(3)}></label>
          <input id={'ambitious_big'+this.props.pergunta.mIdCampanhaPergunta}  type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="1"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/ambitious_big.png)'}} className="drinkcard-cc" htmlFor={'ambitious_big'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(4)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(4)}></label>
          <input id={'smile_big'+this.props.pergunta.mIdCampanhaPergunta}  type="radio" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="1"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/smile_big.png)'}} className="drinkcard-cc" htmlFor={'smile_big'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(5)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(5)}></label>
        </div>

    );
  }
}
RatingEmoji.contextTypes = {
  router: React.PropTypes.object
};



export default RatingEmoji;



/** WEBPACK FOOTER **
 ** ./src/components/RatingEmoji.js
 **/